import react, { useEffect, useState, useRef, useContext } from 'react'
import { Link } from 'react-router-dom';
import useSize from 'hooks/useSize'
import {AuthContext} from "context/authProvider";

function Menu() {
    let [height, setHeight] = useState(0);
    let container = useRef(null);
    useEffect(() => {
        if(container && container.current) {
            setHeight(container.current.offsetHeight);
        }
    }, [])

    const {auth} = useContext(AuthContext);
    const superAccess = ['super_user']

return (
    <ul className="navbar-nav left-nav" ref={container}>
{superAccess.find(role => auth?.role?.includes(role)) &&
        <li className="nav-item">
            <Link to="/" className="nav-link">
                <i className="icons icons-over"></i>
                <div className="nav-link-text">Overview </div>
            </Link>
        </li>
}
        <li className="nav-item">
            <Link to="/unitsOverview" className="nav-link">
                <i className="icons icons-units"></i>
                <div className="nav-link-text">Units Overview</div>
            </Link>
        </li>
    
        <li className="nav-item">
            <Link to="/myProfile" className="nav-link">
                <i className="icons icons-profile"></i>
                <div className="nav-link-text">My Profile</div>
            </Link>
        </li>

        <li className="nav-item">
            <Link to="/myLicense" className="nav-link">
                <i className="icons icons-licenses"></i>
                <div className="nav-link-text">My License</div>
            </Link>
        </li>

        <li className="nav-item">
            <a href="https://www.zuragon.com/help/#support" target="_blank" className="nav-link">
                <i className="icons icons-support"></i>
                <div className="nav-link-text">Support Center</div>
            </a>
        </li>

        <li className="nav-item">
            <a href="https://www.zuragon.com/downloads/" target="_blank" className="nav-link">
                <i className="icons icons-download"></i>
                <div className="nav-link-text">Download Center</div>
            </a>
        </li>
{superAccess.find(role => auth?.role?.includes(role)) &&
        <div className="super-user">
            <li className="nav-item">
                <Link to="/users" className="nav-link">
                    <i className="icons icons-users"></i>
                    <div className="nav-link-text">Users</div>
                </Link>
            </li>

            <li className="nav-item">
                <Link to="/companies" className="nav-link">
                    <i className="icons icons-companies"></i>
                    <div className="nav-link-text">Companies</div>
                </Link>
            </li>

            <li className="nav-item">
                <Link to="/unitsManagement" className="nav-link">
                    <i className="icons icons-management"></i>
                    <div className="nav-link-text">Units Management</div>
                </Link>
            </li>

            <li className="nav-item">
                <Link to="/systemEvents" className="nav-link">
                    <i className="icons icons-events"></i>
                    <div className="nav-link-text">System Events</div>
                </Link>
            </li>

            <li className="nav-item">
                <Link to="/licenses" className="nav-link">
                    <i className="icons icons-vicandolicences"></i>
                    <div className="nav-link-text">ViCANdo Licenses</div>
                </Link>
            </li>

            <li className="nav-item">
                <Link to="/crashReports" className="nav-link">
                    <i className="icons icons-crash"></i>
                    <div className="nav-link-text">Crash Reports</div>
                </Link>
            </li>
        </div> 
}
    </ul>
)

}

export default Menu